import { useMemo } from 'react'

import { CircleQuestionMark } from 'lucide-react'

import { Widget, WidgetContent, WidgetHeaderWithQuery } from '@fortem-monorepo/react-spa'
import { ICReport } from '@fortem-monorepo/web-sdk'

import { PerIssuerNotionalCharts } from '@/pages/funds/ic-report/components/primitives/charts/PerIssuerNotionalCharts'
import { PerIssuerWgtCharts } from '@/pages/funds/ic-report/components/primitives/charts/PerIssuerWgtCharts'
import { labels } from '@/pages/funds/ic-report/constants'
import { income } from '@/react-query/queries/ic-report/hooks'

export interface PerIssuerProps {
  params: Omit<ICReport.GetICReportDataParams, 'endpoint'>
}

export const PerIssuer: React.FC<PerIssuerProps> = ({ params }) => {
  const query = income.usePerIssuer(params)

  const _labels = useMemo(() => {
    return labels.income.breakdown_per_issuer()
  }, [])

  return (
    <div className="grid gap-4">
      <Widget>
        <WidgetHeaderWithQuery query={query} title="Breakdown Per Issuer" />
        <WidgetContent loading={query.isLoading}>
          {_labels.descriptions?.widget && (
            <div className="flex items-center gap-2 px-3 py-2 text-sm border-b bg-sidebar text-muted-foreground">
              <CircleQuestionMark size={16} className={'text-blue-600 shrink-0'} />
              {_labels.descriptions?.widget}
            </div>
          )}
          <PerIssuerWgtCharts params={params} />
          <PerIssuerNotionalCharts params={params} />
        </WidgetContent>
      </Widget>
    </div>
  )
}
